import { render, staticRenderFns } from "./CalendarMonth.vue?vue&type=template&id=2a20fac1&"
import script from "./CalendarMonth.vue?vue&type=script&lang=js&"
export * from "./CalendarMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports